import { render, staticRenderFns } from "./QuotaLimitPeriod.vue?vue&type=template&id=4ecb09b8&"
import script from "./QuotaLimitPeriod.vue?vue&type=script&lang=js&"
export * from "./QuotaLimitPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ecb09b8')) {
      api.createRecord('4ecb09b8', component.options)
    } else {
      api.reload('4ecb09b8', component.options)
    }
    module.hot.accept("./QuotaLimitPeriod.vue?vue&type=template&id=4ecb09b8&", function () {
      api.rerender('4ecb09b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point/PointQuotaLimit/components/QuotaLimitPeriod.vue"
export default component.exports